import { useHeaders } from "@contexts/HeaderContext";
import { CountryCode } from "libphonenumber-js";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import PhoneInput from "react-phone-number-input/input";

interface IInputFieldPhone {
  label: string;
  name: "fullName" | "email" | "phoneNumber";
  isOnStickyRaQ?: boolean;
  isContactForm?: boolean;
  hasAsterisk?: boolean;
}

const InputPhone = ({
  label,
  name,
  isOnStickyRaQ = false,
  isContactForm = false,
  hasAsterisk = false,
}: IInputFieldPhone): JSX.Element => {
  const [hasSmallLabel, setHasSmallLabel] = useState(false);
  const formContext = useFormContext();
  const { headers } = useHeaders();
  const country = (
    headers && headers["cf-ipcountry"] ? headers["cf-ipcountry"] : "US"
  ) as CountryCode;

  useEffect(() => {
    if (formContext.getValues(name)) {
      setHasSmallLabel(true);
    } else {
      setHasSmallLabel(false);
    }
  }, [formContext.watch(name)]);
  const error = formContext.formState.errors[name];
  const labelId = `label-${name}`;

  return (
    <div
      className={`float-input-container ${isContactForm ? "contact-us" : ""}`}
    >
      <Controller
        name={name}
        control={formContext.control}
        render={({ field }) => (
          <PhoneInput
            id={name}
            aria-labelledby={labelId}
            aria-label={label}
            {...field}
            className={`${isOnStickyRaQ ? "autofill-bg-white !bg-white" : ""} ${
              error ? "error-field" : ""
            }`}
            country={country}
            onChange={field.onChange}
          />
        )}
      />
      <label
        htmlFor={name}
        id={labelId}
        className={`
        ${hasSmallLabel ? "active-float-label" : ""} `}
      >
        {label}
        {hasAsterisk ? "*" : ""}
      </label>
      {error && <span className="error-text">{error.message}</span>}
    </div>
  );
};

export default InputPhone;
